import { render } from "./TestPlanTable.vue?vue&type=template&id=44ce1068&scoped=true"
import script from "./TestPlanTable.vue?vue&type=script&lang=js"
export * from "./TestPlanTable.vue?vue&type=script&lang=js"

import "./TestPlanTable.vue?vue&type=style&index=0&id=44ce1068&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ce1068"]])

export default __exports__